let instance = null;

const initialize = () => {

    instance = (
        ScrollSmoother.create({
            smooth: 0.2,
            smoothTouch: 0.1,
        })
    );
};

const getInstance = () => instance;

export default {
    initialize,
    getInstance,
};

